import React from "react";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

// Выбранный товар хранит родитель (список компаний): по нему же отбираются строки таблицы.
function Statistic(props) {
  const { selectedProduct, onProductChange } = props;

  let products = {};

  props.tableDescription.data.forEach(item => {
    if (item.leftovers || item.sowingareas) {
      Object.keys({ ...item.leftovers, ...item.sowingareas }).forEach(key => {
        if (!products[key]) {
          products[key] = { leftovers: 0, sowingareas: 0 };
        }
        // Значения приходят строками ("0.00") или null: складываем только как числа,
        // иначе "0" + "0.00" + null превращается в строку "00.00null".
        if (item.leftovers && item.leftovers[key] !== undefined) {
          products[key].leftovers += Number(item.leftovers[key]) || 0;
        }
        if (item.sowingareas && item.sowingareas[key] !== undefined) {
          products[key].sowingareas += Number(item.sowingareas[key]) || 0;
        }
      });
    }
  });

  const productKeys = Object.keys(products);

  // Filter all the products we want to see

  const visibleProducts = props.tableDescription.productTypes
    .filter(product => product.is_visible)
    .map(product => product.name);

  const filteredProductKeys = productKeys.filter(key => visibleProducts.includes(key));

  const chosen = products[selectedProduct];

  return (
    <Grid component={Paper} item style={{ padding: "10px", marginBottom: "10px" }}>
      <Grid container alignItems="center" spacing={2}>
        <Grid item>
          <Typography style={{ fontSize: "22px", marginRight: "10px" }} variant="caption">
            Выберите товар:
          </Typography>
        </Grid>
        <Grid item>
          <FormControl variant="outlined" style={{ minWidth: 250 }}>
            <Select
              value={selectedProduct}
              onChange={(event) => onProductChange(event.target.value)}
              displayEmpty
            >
              <MenuItem value="">Все товары</MenuItem>
              {filteredProductKeys.map((key, index) => (
                <MenuItem key={index} value={key}>
                  {key}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {chosen && (
          <>
            <Grid item>
              <Typography style={{ fontSize: "22px", marginLeft: "20px" }} variant="caption">
                Сумма остатков: {chosen.leftovers} Тн
              </Typography>
            </Grid>
            <Grid item>
              <Typography style={{ fontSize: "22px", marginLeft: "20px" }} variant="caption">
                Площадь посева: {chosen.sowingareas} Га
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </Grid>
  );
}

export default Statistic;
